import { ReactNode } from 'react'

import { Link } from '~/components/Link'

export default function ButtonOrange({
  onClick = () => {},
  children,
  to,
  disabled = false,
}: {
  onClick?: () => void
  children: ReactNode
  to?: string
  disabled?: boolean
}): React.ReactElement {
  if (to) {
    return (
      <Link
        className="flex justify-center items-center rounded w-full h-12 bg-orange text-black tracking-btn-wide font-bold hover:scale-105 duration-300 shadow-task-light-orange text-center mx-auto"
        onClick={onClick}
        to={to}
      >
        {children}
      </Link>
    )
  }
  return (
    <button
      className="flex justify-center items-center rounded w-full h-12 bg-orange text-black font-bold hover:scale-105 duration-300 shadow-task-light-orange text-center mx-auto disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
